/**
 * Open a URL in the user's default system browser.
 * In Word, `window.open` opens an Office dialog — use `openBrowserWindow` instead.
 */
export function openExternalUrl(url: string): void {
  const trimmed = url.trim();
  if (!trimmed) return;

  try {
    if (typeof Office !== 'undefined' && typeof Office.context?.ui?.openBrowserWindow === 'function') {
      const requirements = Office.context.requirements;
      const supported =
        !requirements?.isSetSupported ||
        requirements.isSetSupported('OpenBrowserWindowApi', '1.1');
      if (supported) {
        Office.context.ui.openBrowserWindow!(trimmed);
        return;
      }
    }
  } catch {
    /* fall through to window.open */
  }

  window.open(trimmed, '_blank', 'noopener,noreferrer');
}
